import { DiscordSDK, DiscordSDKMock, Events, Platform, Common, Commands, Permissions, PermissionUtils, PriceUtils, RPCCloseCodes, RPCErrorCodes, Responses, patchUrlMappings, attemptRemap } from  '@discord/embedded-app-sdk';
import type { IDiscordSDK, CommandTypes, CommandInput, CommandInputTypes, CommandResponse, CommandResponseTypes, ISDKError, Types } from  '@discord/embedded-app-sdk';

export var discordSdk: DiscordSDK | DiscordSDKMock;
export type DiscordEvent = "READY" | "VOICE_STATE_UPDATE" | "SPEAKING_START" | "SPEAKING_STOP"
 | "ACTIVITY_LAYOUT_MODE_UPDATE" | "ORIENTATION_UPDATE" | "CURRENT_USER_UPDATE" 
 | "ENTITLEMENT_CREATE" | "THERMAL_STATE_UPDATE" | "ACTIVITY_INSTANCE_PARTICIPANTS_UPDATE";

// Type guard to ensure event is of type DiscordEvent
export function isValidEvent(event: string): event is DiscordEvent {
  return [
    "READY",
    "VOICE_STATE_UPDATE",
    "SPEAKING_START",
    "SPEAKING_STOP",
    "ACTIVITY_LAYOUT_MODE_UPDATE",
    "ORIENTATION_UPDATE",
    "CURRENT_USER_UPDATE",
    "ENTITLEMENT_CREATE",
    "THERMAL_STATE_UPDATE",
    "ACTIVITY_INSTANCE_PARTICIPANTS_UPDATE"
  ].includes(event);
}
 

export var instanceId: string;
//export var username: string = 'mockUsername';


type Auth = CommandResponse<'authenticate'>;
export var auth: Auth;

const queryParams = new URLSearchParams(window.location.search);

export var isEmbedded = queryParams.get('frame_id') != null;

export enum SessionStorageQueryParam {
  user_id = 'user_id',
  guild_id = 'guild_id',
  channel_id = 'channel_id',
}


export function checkProxy():boolean{
  return window.location.href.indexOf(".discordsays.com/") !== -1;
}

/**
 * This function should be called from the top-level of your embedded app
 * It initializes the SDK, then authorizes, and authenticates the embedded app
 */
const CLIENT_ID = process.env.CLIENT_ID??"1258530387605327983";

/*export async function initializeSdk(): Promise<DiscordSDK> {
  if (typeof CLIENT_ID !== 'string') {
    throw new Error("Must specify 'CLIENT_ID");
  }
  const discordSdk = new DiscordSDK(CLIENT_ID);
  await discordSdk.ready();

  // Pop open the OAuth permission modal and request for access to scopes listed in scope array below
  const {code} = await discordSdk.commands.authorize({
    client_id: CLIENT_ID,
    response_type: 'code',
    state: '',
    prompt: 'none',
    scope: ['identify', 'email', 'applications.commands', 'rpc.activities.write', 'rpc.voice.read', 'guilds.members.read'],
  });

  const isProxy:boolean = checkProxy();

  // Retrieve an access_token from your embedded app's server
  const response = await fetch((isProxy ? '/.proxy' : '') + '/api/token', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      code,
    }),
  });

  const {access_token} = await response.json();

  // Authenticate with Discord client (using the access_token)
  await discordSdk.commands.authenticate({
    access_token,
  });

  return discordSdk;
}*/

if (isEmbedded && checkProxy()) {
  discordSdk = new DiscordSDK(CLIENT_ID);
  instanceId = discordSdk.instanceId;
} else {
  instanceId = /*"mockInstanceId"*/ "mockInstanceId1";

  const mockUserId = getOverrideOrRandomSessionValue('user_id');
  const mockGuildId = getOverrideOrRandomSessionValue('guild_id');
  const mockChannelId = getOverrideOrRandomSessionValue('channel_id');

  discordSdk = new DiscordSDKMock(CLIENT_ID, mockGuildId, mockChannelId, null);
  const discriminator = String(mockUserId.charCodeAt(0) % 5);

  function getOverrideOrRandomSessionValue(queryParam: `${SessionStorageQueryParam}`) {
    const overrideValue = queryParams.get(queryParam);
    if (overrideValue != null) {
      return overrideValue;
    }

    const currentStoredValue = sessionStorage.getItem(queryParam);
    if (currentStoredValue != null) {
      return currentStoredValue;
    }

    const randomString = Math.random().toString(36).slice(2, 10);
    sessionStorage.setItem(queryParam, randomString);
    return randomString;
  }

  discordSdk._updateCommandMocks({
    authenticate: async (data:any) => {
      return await {
        access_token: /*'mock_token'*/ data.access_token,
        my_access_token: 'mock_token',
        user: {
          username: mockUserId,
          discriminator,
          id: mockUserId,
          avatar: null,
          public_flags: 1,
        },
        scopes: [],
        expires: new Date(2112, 1, 1).toString(),
        application: {
          description: 'mock_app_description',
          icon: 'mock_app_icon',
          id: 'mock_app_id',
          name: 'mock_app_name',
        },
      };
    },
  });
}

export async function setupDiscordSdk() {
  /*if(discordSdk == null) {
    discordSdk = await initializeSdk();
  }*/

  let myAccessToken:any;

  if(checkProxy()) {
    console.log("refer" + document.referrer);
    await discordSdk.ready();
    const { enabled } = await discordSdk.commands.encourageHardwareAcceleration();
    console.log(`Hardware Acceleration is ${enabled === true ? 'enabled' : 'disabled'}`);

    const { code } = await discordSdk.commands.authorize({
      client_id: CLIENT_ID,
      response_type: 'code',
      state: '',
      prompt: 'none',
      scope: [
        'applications.commands',
        'identify',
        'guilds',
        'email', 
        'guilds.members.read'
      ],
    });

    try {
      console.log("code:");
      console.log(code);

      const isProxy:boolean = checkProxy();

      const response = await fetch((isProxy ? '/.proxy' : '') + '/api/token', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ code }),
      });
      
      if (!response.ok) {
        console.log("response");
        console.log(response);
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      const data = await response.json();
      // Handle the response data
      console.log('Response data:', data);
      if (!data) {
        throw new Error('No data received');
      }

      myAccessToken = data.access_token/*.access_token*/;
    } catch (error) {
      console.error('Error during fetch:', error);
    }
  }else{
    //Try website request for authentication
    const response = await fetch('https://warmerise.com/sso/tokens?cancel=1', {
      method: 'GET', 
      credentials: 'include'
    });
    
    if (!response.ok) {
      console.log("response");
      console.log(response);
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    const data = await response.json();
    // Handle the response data
    console.log('Response data:', data);
    if (!data) {
      throw new Error('No data received');
    }

    myAccessToken = data./*discord_access_token*/ discord_access_data;
  }
    
  //const myAccessToken = data ? data.access_token.access_token : (secondary_data ? secondary_data.discord_access_token : '');
  if (!myAccessToken && isEmbedded &&  checkProxy()) {
    //throw new Error('Access token not found in response data');
    console.error('Access token not found in response data')
  }else{
    console.log('Access Token:', myAccessToken);
    auth = await discordSdk.commands.authenticate({
      access_token: myAccessToken.access_token, // Use the correct variable here
    });
  }
  
  if (auth == null) {
    //throw new Error('Authenticate command failed');
    console.error('Authenticate command failed');
  }else{
    auth.access_token = myAccessToken ? JSON.stringify(myAccessToken) : "";
  }

  //console.log("Authentication:", auth);
  
  //username = data ? data.username : (secondary_data ? secondary_data.username : '');
  //username = auth.user.username;
}


export interface DiscordParticipant {  
    username: string;
    discriminator: string;
    id: string;
    bot: boolean;
    flags: number;
    avatar?: string | null | undefined;
    global_name?: string | null | undefined;
    avatar_decoration_data?: {
        asset: string;
        skuId?: string | undefined;
    } | null | undefined;
    premium_type?: number | null | undefined;
    nickname?: string | undefined;

}

export interface DiscordUsers {
  participants: DiscordParticipant[]
}

export interface DiscordVoiceChannelInfo {
  channel: any,
  users: DiscordUsers,
  usernames: string[]
}

export async function appendVoiceChannelName(): Promise<DiscordVoiceChannelInfo | null> {
  //const app = document.querySelector('#app');
  //let activityChannelName = 'Unknown';

  if (discordSdk.channelId != null && discordSdk.guildId != null) {
    const channel = await discordSdk.commands.getChannel({ channel_id: discordSdk.channelId });
    const users = await discordSdk.commands.getInstanceConnectedParticipants();
    const usernames = users.participants.map(participant => participant.username);      


    return {
      channel: channel,
      users: users,
      usernames: usernames
    };
  
  } else {
    return null;
  }
}